export default {
  DOCS: 'DOCS',
  DOCO: 'DOCO',
  PCTC: 'PCTC',
  TSA: 'RTSA',
  DOCA: 'DOCA'
}
